import { render, staticRenderFns } from "./PendingNACEX.vue?vue&type=template&id=96383ca2"
import script from "./PendingNACEX.vue?vue&type=script&lang=js"
export * from "./PendingNACEX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports